var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructorVectorRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 64,
    viewBox: "0 0 32 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3309 31.9954C19.3309 42.5049 10.9456 51.0547 0.5 51.3199V63.4961C17.666 63.229 31.5 49.2296 31.5 32C31.5 14.7704 17.666 0.771035 0.5 0.503888V12.6709C10.9456 12.936 19.3309 21.4858 19.3309 31.9954Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructorVectorRight);
export default __webpack_public_path__ + "static/media/instructor-vector-right.ec7944be3eb373d14088a52ac16aa9f6.svg";
export { ForwardRef as ReactComponent };